/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformEphemerisSegmentsResponse } from '../../models/platform-ephemeris-segments-response';

export interface GetEphemerisSegments$Params {

/**
 * Begin van het venster (ISO-8601, UTC). Verplicht.
 */
  fromUtc?: string | null;

/**
 * Einde van het venster (ISO-8601, UTC). Verplicht, moet na fromUtc liggen.
 */
  toUtc?: string | null;

/**
 * Optioneel: komma-gescheiden sourceKeys (bv. "sun,moon,chiron"). Default: alle 14.
 */
  planets?: string | null;

/**
 * "gate" of "line" (case-insensitive). Default "line".
 *             Bereik: line ≤ 92 dagen, gate ≤ 5 jaar — bij overschrijding 400 met een suggestion.
 */
  granularity?: string | null;
}

export function getEphemerisSegments(http: HttpClient, rootUrl: string, params?: GetEphemerisSegments$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformEphemerisSegmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getEphemerisSegments.PATH, 'get');
  if (params) {
    rb.query('fromUtc', params.fromUtc, {});
    rb.query('toUtc', params.toUtc, {});
    rb.query('planets', params.planets, {});
    rb.query('granularity', params.granularity, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformEphemerisSegmentsResponse>;
    })
  );
}

getEphemerisSegments.PATH = '/api/Ephemeris/segments';
